import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllOrigenes = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataOrigenes, setDataOrigenes ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllOrigenes, setLoadingFetchAllOrigenes ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {            
            const response = await marvarApi.get(`/origenes-creditos/fetch-all-origenes`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllOrigenes(true)
        fetchData()
            .then((resp) => {
                setDataOrigenes(resp.rows)
                setLoadingFetchAllOrigenes(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllOrigenes(false)
            })
    }, [execute])

    return {  dataOrigenes, loadingFetchAllOrigenes, executeFetch }

}

export const useFetchSpecificOrigen = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificOrigen, setLoadingFetchSpecificOrigen ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idorigen: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/origenes-creditos/fetch-specific-origen/${paramsToSearch.idorigen}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idorigen > 0 ){
            setLoadingFetchSpecificOrigen(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idorigen: rows[0].idorigen || '',
                        nombre: rows[0].nombre || ''
                    }))
                    setLoadingFetchSpecificOrigen(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificOrigen(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificOrigen, setParamsToSearch, executeFetch }

}